import React, { useEffect, useState } from 'react'
import './TransactionsReport.scss'
import { Container, Grid } from '@mui/material'
import { useCMSContext } from './../../CMSContext'

import { format, subDays } from 'date-fns'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import CustomTable from '../../../Shared/CustomTable/CustomTable'
import TransactionsReportActions from './TransactionsReportActions'
import SECTIONS_TYPES from '../../../../Constants/SectionsTypes'
import LoadingSpinner from '../../../Shared/LoadingSpinner/LoadingSpinner'

import SectionTypeSelect from './components/SectionTypeSelect'
import DowloadReport from './components/DowloadReport'
import DateInput from './components/DateInput'
import SearchButton from './components/SearchButton'

const TransactionsReport = () => {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  const [startDate, setStartDate] = useState(subDays(new Date(), 30))
  const [endDate, setEndDate] = useState(new Date())
  const [transactionsReportEntity, setTransactionsReportEntity] = useState([])
  const [sectionType, setSectionType] = useState(SECTIONS_TYPES.HOME)
  const [transactionsData, setTransactionsData] = useState([])
  const [posting, setPosting] = useState(false)
  const { state } = useCMSContext()
  const { isReadOnlyMember, fireDepartment } = state
  const [showMarketingLabel, setShowMarketingLabel] = useState(false)

  const DATE_FORMAT_PATTERN = 'yyyy-MM-dd'
  const COLUMNS = [
    { id: 'localDate', type: 'string', label: 'Date' },
    { id: 'memberName', type: 'string', label: 'Member name' },
    { id: 'sectionType', type: 'string', label: 'Section type' },
    { id: 'currentSectionName', type: 'string', label: 'Section name' },
    { id: 'movementType', type: 'string', label: 'Movement type' }
  ]

  Interceptor.interceptor(errorSnackBarActions)

  useEffect(() => {
    let formatedTransactionsData = []
    if (transactionsReportEntity?.length > 0) {
      formatedTransactionsData = transactionsReportEntity.map((elem) => {
        let dateToDisplay = TransactionsReportActions.formatMovementDate(elem.localDate)

        return {
          date: elem.date,
          localDate: dateToDisplay,
          memberName: elem.memberName,
          sectionType: elem.sectionType,
          movementType: elem.movementType,
          currentSectionName: elem.currentSectionName
        }
      })
    }
    setTransactionsData(formatedTransactionsData)
  }, [transactionsReportEntity])

  useEffect(() => {
    if (sectionType === 'marketing') {
      setShowMarketingLabel(true)
    } else {
      setShowMarketingLabel(false)
    }
  }, [transactionsData])

  const fetchTransactionLogs = async () => {
    try {
      const payload = {
        sectionType: sectionType,
        fromLocalDate: format(startDate, DATE_FORMAT_PATTERN),
        toLocalDate: format(endDate, DATE_FORMAT_PATTERN)
      }
      const response = await TransactionsReportActions.getTransactionsReport(
        JSON.stringify(payload)
      )
      if (response) {
        setTransactionsReportEntity(response)
      }
      setPosting(false)
    } catch (error) {
      setPosting(false)
      showErrorSnack('Something was wrong fetching information')
    }
  }

  const showErrorSnack = (errorMessage) => {
    errorSnackBarActions.setOpen(true, errorMessage, 'warning')
  }

  const onSearchHandler = () => {
    setPosting(true)
    const searchValidation = TransactionsReportActions.searchTransactionLogs(startDate, endDate)
    if (!searchValidation.result) {
      setPosting(false)
      showErrorSnack(searchValidation.message)
      return
    }
    fetchTransactionLogs()
  }

  return (
    <div className="transactions-report">
      <div className="transactions-page-header">
        <span>Transactions Report</span>
      </div>
      <Container maxWidth="lg">
        <Grid container className="transactions-controls" spacing={3}>
          <Grid
            container
            size={{ xs: 12 }}
            columnSpacing={2}
            className="transactions-controls-container"
          >
            {transactionsData.length > 0 && <DowloadReport transactions={transactionsData} />}
            <SectionTypeSelect setSectionType={setSectionType} isAdmin={isReadOnlyMember} />
            <DateInput
              title={'Start Date'}
              id={'startDate'}
              format={DATE_FORMAT_PATTERN}
              value={startDate}
              setDay={setStartDate}
            />
            <DateInput
              title={'End Date'}
              id={'endDate'}
              format={DATE_FORMAT_PATTERN}
              value={endDate}
              setDay={setEndDate}
            />
            <SearchButton text={'search'} disbled={posting} onClick={onSearchHandler} />
          </Grid>
          {showMarketingLabel && !posting && (
            <div className="note-label">
              <span>{'Marketing custom section dates are displayed in Central Time'}</span>
            </div>
          )}
          <Grid size={12} className="transactions-table-container">
            {posting ? (
              <LoadingSpinner />
            ) : (
              <CustomTable
                data={transactionsData}
                dataStateSetter={setTransactionsData}
                columns={COLUMNS}
                tableSize="small"
                orderByDefaultProperty="date"
                timeZone={fireDepartment?.timezone}
                sectionType={sectionType}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default TransactionsReport
